import {
  isHomeReplySignatureWorkspace,
  replySignatureWorkspaceName,
} from "@/modules/tickets/lbsDefaultReplySignature";
import { LBS_SUPPORT_SIGNATURE } from "@/modules/tickets/ticketReplyTemplates";

export type TicketCreateTemplateId = "welcome_es";

export type TicketCreateTemplate = {
  id: TicketCreateTemplateId;
  label: string;
  description: string;
  body: string;
};

export type TicketCreateTemplateContext = {
  clientName: string;
  subject: string;
};

/** The home org's (LBS) built-in templates. */
export const TICKET_CREATE_TEMPLATES: TicketCreateTemplate[] = [
  {
    id: "welcome_es",
    label: "Welcome (ES)",
    description: "Greeting message for a new support case.",
    body: `Hola {{clientName}},

Gracias por contactar a Latino Business Support. Hemos registrado su caso relacionado con {{subject}} y nuestro equipo lo revisará a la brevedad.

Si tiene documentos o información adicional, puede responder a este hilo o escribirnos a supplements@lbs.bz.

Saludos cordiales,

${LBS_SUPPORT_SIGNATURE}`,
  },
];

/** Other companies: same greeting, signed with their own name. */
const WORKSPACE_TICKET_CREATE_TEMPLATES: TicketCreateTemplate[] = [
  {
    id: "welcome_es",
    label: "Welcome (ES)",
    description: "Greeting message for a new support case.",
    body: `Hola {{clientName}},

Gracias por contactarnos. Hemos registrado su caso relacionado con {{subject}} y nuestro equipo lo revisará a la brevedad.

Si tiene documentos o información adicional, puede responder a este correo.

Saludos cordiales,

{{companyName}}`,
  },
];

/** Built-in create templates for the signed-in member's company. */
export const getTicketCreateTemplates = () =>
  isHomeReplySignatureWorkspace()
    ? TICKET_CREATE_TEMPLATES
    : WORKSPACE_TICKET_CREATE_TEMPLATES;

export const expandTicketCreateTemplate = (
  template: string,
  context: TicketCreateTemplateContext,
) =>
  template
    .replace(/\{\{clientName\}\}/g, context.clientName)
    .replace(/\{\{subject\}\}/g, context.subject)
    .replace(/\{\{companyName\}\}/g, replySignatureWorkspaceName());

export const renderTicketCreateTemplate = (
  templateId: TicketCreateTemplateId,
  context: TicketCreateTemplateContext,
) => {
  const template = getTicketCreateTemplates().find(
    (row) => row.id === templateId,
  );
  if (!template) return "";
  return expandTicketCreateTemplate(template.body, context);
};
